(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fw-last-chance"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mount(root) {
    if(root.dataset.mounted) return;
    root.dataset.mounted='true';
    const key='fw-last-chance-dismissed';
    let dismissed=false, ready=false, fetching=false;
    try{dismissed=sessionStorage.getItem(key)==='1';}catch(e){}
    const show=()=>{root.hidden=!(ready&&!dismissed&&root.dataset.eligible==='true');};
    root.querySelector('.fw-last-chance__close').addEventListener('click',()=>{
      dismissed=true;root.hidden=true;
      try{sessionStorage.setItem(key,'1');}catch(e){}
    });
    const refresh=async()=>{
      if(dismissed||fetching||document.hidden) return;
      fetching=true;
      try{
        const url=new URL(window.location.href);
        url.searchParams.set('sections',root.dataset.section);
        url.searchParams.set('_stock',Date.now());
        const response=await fetch(url.toString(),{cache:'no-store',credentials:'same-origin'});
        if(!response.ok) return;
        const sections=await response.json();
        const html=sections[root.dataset.section];
        if(!html) return;
        const fresh=new DOMParser().parseFromString(html,'text/html').querySelector('[data-fw-last-chance]');
        if(!fresh) return;
        root.dataset.eligible=fresh.dataset.eligible;
        root.dataset.count=fresh.dataset.count;
        root.querySelector('[data-stock-count]').textContent=fresh.dataset.count;
        show();
      }catch(e){}finally{fetching=false;}
    };
    setTimeout(()=>{ready=true;show();refresh();},7000);
    setInterval(refresh,60000);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
    window.addEventListener('pageshow',refresh);
  }
  document.querySelectorAll('[data-fw-last-chance]').forEach(mount);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-fw-last-chance]').forEach(mount));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-routine-quiz"] && !Shopify.designMode) return;
  try {
    
function initRoutinePreview() {
document.querySelectorAll('.fw-routine-quiz').forEach(section => {
if(section.dataset.previewReady)return;
section.dataset.previewReady='true';
const tabs=Array.from(section.querySelectorAll('[role="tab"]'));
function select(tab,focus){tabs.forEach(item=>{
const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;
section.querySelector('#'+CSS.escape(item.getAttribute('aria-controls'))).hidden=!selected;
});if(focus)tab.focus();}
tabs.forEach((tab,index)=>{
tab.addEventListener('click',()=>select(tab,false));
tab.addEventListener('keydown',event=>{
let next;
if(event.key==='ArrowRight')next=(index+1)%tabs.length;
if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
if(event.key==='Home')next=0;
if(event.key==='End')next=tabs.length-1;
if(next!==undefined){event.preventDefault();select(tabs[next],true);}
});
});
});
}
initRoutinePreview();
document.addEventListener('shopify:section:load',initRoutinePreview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-saffron-gold-results"] && !Shopify.designMode) return;
  try {
    
if (!window.fwGoldCarouselBound) {
  window.fwGoldCarouselBound = true;
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-gold-prev], [data-gold-next]');
    if (!button) return;
    const root = button.closest('.fw-gold-results');
    const track = root && root.querySelector('.fw-gold-results__track');
    if (!track) return;
    const cards = Array.from(track.querySelectorAll('.fw-gold-results__card'));
    if (!cards.length) return;
    const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    const maximum = track.scrollWidth - track.clientWidth;
    const forward = button.hasAttribute('data-gold-next');
    const current = track.scrollLeft;
    const target = forward ? (current >= maximum - 2 ? 0 : Math.min(maximum, current + step)) : (current <= 2 ? maximum : Math.max(0, current - step));
    track.scrollTo({ left: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-sbf-science"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-sbf-tabs]').forEach(root => {
  const tabs = [...root.querySelectorAll('[data-sbf-tab]')];
  const panels = [...root.querySelectorAll('[role="tabpanel"]')];
  const select = (index, focus) => {
    tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
    if (focus) tabs[index].focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index, false));
    tab.addEventListener('keydown', event => {
      let next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault(); select(next, true);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
